import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

interface TextPlaceholderProps {
  translationKey: string;
  replacements?: { [key: string]: string | number };
  className?: string;
  fallbackText?: string;
  minHeight?: string;
  skeleton?: boolean;
}

/**
 * Componente che previene layout shift durante il caricamento delle traduzioni
 * mostrando uno skeleton o placeholder di dimensione fissa
 */
const TextPlaceholder: React.FC<TextPlaceholderProps> = ({
  translationKey,
  replacements,
  className = '',
  fallbackText,
  minHeight = '1.5em',
  skeleton = true
}) => {
  const { t, isLoaded } = useTranslation();

  // Se le traduzioni sono caricate, mostra il testo normale
  if (isLoaded) {
    return <span className={className}>{t(translationKey, replacements)}</span>;
  }

  // Durante il caricamento, mostra skeleton o fallback
  if (skeleton) {
    return (
      <span 
        className={`${className} inline-block bg-gray-200 animate-pulse rounded`}
        style={{ minHeight, minWidth: '8ch' }}
        aria-label="Loading text..."
      >
        &nbsp;
      </span>
    );
  }

  // Fallback text con dimensione minima
  return (
    <span 
      className={className}
      style={{ minHeight }}
    >
      {fallbackText || translationKey}
    </span>
  );
};

export default TextPlaceholder;